<template>
  <div
    v-if="!calendarRules || calendarRules.length === 0"
    class="px-1 small text-secondary"
  >
    -
  </div>
  <div
    v-else
    class="px-1 small"
  >
    {{ formattedRules }}
  </div>
</template>

<script>
const weekDayMap = {
  Sunday: 'Ndz',
  Monday: 'Pon',
  Tuesday: 'Wt',
  Wednesday: 'Śrd',
  Thursday: 'Czw',
  Friday: 'Pt',
  Saturday: 'Sob',
};

export default {
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
  computed: {
    calendarRules() {
      return this.order.listing?.calendarRules || [];
    },
    formattedRules() {
      if (!this.calendarRules || this.calendarRules.length === 0) {
        return '-';
      }

      return this.calendarRules
        .map((rule) => {
          // Handle both full weekday names and numeric indices
          let { weekDay } = rule;

          if (typeof rule.weekDay === 'string') {
            // Full weekday name from API (e.g., "Monday")
            weekDay = weekDayMap[rule.weekDay] || rule.weekDay;
          } else {
            // Numeric index (legacy fallback)
            const dayIndex = rule.weekDay % 7;
            const dayNamesPolish = ['Ndz', 'Pon', 'Wto', 'Śro', 'Czw', 'Pią', 'Sob'];
            weekDay = dayNamesPolish[dayIndex];
          }

          const startHour = Math.floor(rule.startMinutes / 60);
          const startMin = rule.startMinutes % 60;
          const endMinutes = rule.startMinutes + rule.durationMinutes;
          const endHour = Math.floor(endMinutes / 60);
          const endMin = endMinutes % 60;

          const startTime = `${String(startHour).padStart(2, '0')}:${String(startMin).padStart(2, '0')}`;
          const endTime = `${String(endHour).padStart(2, '0')}:${String(endMin).padStart(2, '0')}`;

          return `${weekDay} ${startTime}-${endTime}`;
        })
        .join(', ');
    },
  },
};
</script>
